import { FLAG_CDN } from '@src/constants';
import Tooltip from '@mui/material/Tooltip';
import styles from './CountryBadge.module.scss';
import { useState } from 'react';

interface CountryBadgeProps {
  countryCode: string;
  countryName?: string;
}

const CountryBadge: React.FC<CountryBadgeProps> = ({ countryCode, countryName = '' }) => {
  const code = countryCode.toLowerCase(); // Flag-CDN uses lowercase codes
  const [isCodeValid, setIsCodeValid] = useState(true);

  if (!isCodeValid) {
    return <span>-</span>;
  }

  return (
    <div className={styles.countryBadgeContainer}>
      <img
        className={styles.countryImage}
        src={`${FLAG_CDN}${code}.png`}
        alt={`Flag of ${countryName || countryCode}`}
        loading="lazy"
        onError={() => setIsCodeValid(false)}
      />

      {countryName?.length > 13 ? (
        <Tooltip title={countryName} placement="top" arrow>
          <span className={styles.countryName}>{countryName}</span>
        </Tooltip>
      ) : (
        <span className={styles.countryName}>{countryName}</span>
      )}
    </div>
  );
};

export default CountryBadge;
